const routesConfig = [
  {
    name: '应用中心',
    shortName: '应用',
    path: '/app-center',
    authId: 1,
    icon: 'iconyunchayingyongzhongxin',
    routes: [
      // {
      //   name: '概览',
      //   authId: 1154,
      //   path: '/app-center/overview/index',
      // },
      {
        name: '数据看板',
        authId: 1227,
        path: '/app-center/datecenter/data-board',
      },
      {
        name: '数据报表',
        authId: 1158,
        path: '/app-center/data/report',
      },
      {
        name: '数据中心',
        authId: 1155,
        path: '/app-center/datecenter',
        routes: [
          {
            name: '门店数据',
            path: '/app-center/datecenter/store-data',
            authId: 1156,
          },
          {
            name: '商品数据',
            path: '/app-center/datecenter/product-data',
            authId: 1157,
          },
        ],
      },
      {
        name: '组织管理',
        authId: 1148,
        path: '/app-center/organization',
        routes: [
          {
            name: '组织架构',
            path: '/app-center/organization/structure',
            authId: 1149,
          },
          {
            name: '渠道管理',
            path: '/app-center/organization/channel',
            authId: 1150,
          },
        ],
      },
      {
        name: '商品',
        path: '/app-center/commodity',
        authId: 3,
        // icon: 'iconyunchashangpin',
        routes: [
          {
            name: '商户商品管理',
            path: '/app-center/commodity/commodity-admin',
            authId: 10,
          },
          {
            name: '门店商品管理',
            path: '/app-center/commodity/store-commodity-admin',
            authId: 1130,
          },
          {
            name: '分类管理',
            path: '/app-center/commodity/commodity-class',
            authId: 11,
          },
          {
            name: '商品规则管理',
            path: '/app-center/commodity/commodity-rules',
            authId: 12,
          },
          {
            name: '进件商品管理',
            path: '/app-center/commodity/in-commodity-admin',
            authId: 1147,
          },
        ],
      },
      {
        name: '门店',
        path: '/app-center/store',
        authId: 4,
        // icon: 'iconyunchamendian',
        routes: [
          {
            name: '门店管理',
            path: '/app-center/store/store-admin',
            authId: 13,
          },
          {
            name: '门店业务管理',
            path: '/app-center/store/store-setting',
            authId: 15,
          },
        ],
      },
      {
        name: '订单',
        path: '/app-center/order',
        authId: 5,
        // icon: 'iconyunchadingdan',
        routes: [
          {
            name: '退款',
            path: '/app-center/order/refund',
            authId: 16,
          },
          {
            name: '订单',
            path: '/app-center/order/list',
            authId: 17,
          },
          {
            name: '售后规则',
            path: '/app-center/order/after-sale-setting',
            authId: 18,
          },
          {
            name: '售后记录',
            path: '/app-center/order/after-sale-list',
            authId: 19,
          },
          // {
          //   name: '报表',
          //   path: '/app-center/order/report',
          //   authId: 20,
          // },
          {
            name: '订单规则设置',
            path: '/app-center/order/order-rule-setting',
            authId: 21,
          },
        ],
      },
      {
        name: '会员',
        authId: 6,
        path: '/app-center/member',
        // icon: 'iconyunchahuiyuan',
        routes: [
          {
            name: '会员配置',
            path: '/app-center/member/member-setting',
            authId: 22,
          },
          {
            name: '会员管理',
            path: '/app-center/member/member-admin',
            authId: 23,
          },
          // {
          //   name: '付费会员',
          //   path: '/app-center/member/member-paid',
          //   authId: 24,
          // },
          {
            name: '会员画像',
            path: '/app-center/member/member-statistical',
            authId: 24,
          },
          {
            name: '会员成长',
            path: '/app-center/member/grade-admin',
            authId: 1193,
          },
        ],
      },
      {
        name: '应用管理',
        authId: 7,
        path: '/app-center/application',
        // icon: 'iconyunchayingyong',
        routes: [
          {
            name: '我的应用',
            path: '/app-center/application/user-app',
            authId: 25,
          },
          {
            name: '应用商城',
            path: '/app-center/application/app-market',
            authId: 26,
          },
        ],
      },
      {
        name: '互动营销',
        authId: 1171,
        path: '/app-center/minigame',
        routes: [
          {
            name: '营销游戏',
            path: '/app-center/minigame/template',
            authId: 1172,
          },
          {
            name: '奖品管理',
            path: '/app-center/minigame/reward',
            authId: 1173,
          },
          {
            name: '参与记录',
            path: '/app-center/minigame/log',
            authId: 1174,
          },
        ],
      },
      {
        name: '小程序',
        authId: 1179,
        path: '/app-center/miniprogram',
        routes: [
          {
            name: '小程序配置',
            path: '/app-center/miniprogram/index',
            authId: 1180,
          },
          {
            name: '模板自定义',
            path: '/retail/customer-page/list',
            authId: 1181,
          },
        ],
      },
      {
        name: '会花助手',
        authId: 1176,
        path: '/app-center/configure',
        routes: [
          {
            name: '巡店打卡记录',
            path: '/app-center/configure/hh-clock-in',
            authId: 1177,
            // icon: 'iconguanlianxianxiashanghu',
          },
          {
            name: '会花助手公告',
            path: '/app-center/configure/hh-notice',
            authId: 1178,
            // icon: 'iconguanlianxianxiashanghu',
          },
          {
            name: '功能模块配置',
            path: '/app-center/configure/hh-function-module',
            authId: 1195,
          },
          {
            name: '门店绑定审核',
            path: '/app-center/configure/hh-store-audit',
            authId: 1196,
          },
          {
            name: '业务员激励',
            path: '/app-center/configure/hh-writeoff-incentives',
            authId: 1223,
          },
        ],
      },
    ],
  },
  {
    name: '设置',
    shortName: '设置',
    path: '/setting',
    authId: 2,
    icon: 'iconyunchashezhi',
    routes: [
      {
        name: '角色管理',
        path: '/main/role',
        authId: 75,
        // icon: 'iconyunchajiaoseguanli',
      },
      {
        name: '账号管理',
        path: '/main/account',
        authId: 76,
        // icon: 'iconyunchazhanghaoguanli',
      },
      {
        name: '支付配置',
        path: '/app-center/configuration/merchant-payment',
        authId: 86,
        // icon: 'iconzhifupeizhi',
      },
      {
        name: '关联线下商户',
        path: '/app-center/configuration/relate-merchant',
        authId: 87,
        // icon: 'iconguanlianxianxiashanghu',
      },
      {
        name: '打款配置',
        path: '/app-center/configure/payment-config',
        authId: 1169,
      },
      {
        name: '操作日志',
        path: '/app-center/configure/operation-log',
        authId: 1194,
      },
      // {
      //   name: '渠道管理',
      //   path: '/intelligent-marketing/marketing/channel-manage',
      //   authId: 100,
      //   // icon: 'iconyunchaqudao',
      //   routes: [
      //     {
      //       name: '企业微信',
      //       path: '/intelligent-marketing/marketing/channel-manage/enterp-wx',
      //       authId: 101,
      //       routes: [
      //         {
      //           name: '授权',
      //           path: '/intelligent-marketing/marketing/channel-manage/enterp-wx/auth',
      //           authId: 103,
      //         },
      //         {
      //           name: '配置',
      //           path: '/intelligent-marketing/marketing/channel-manage/enterp-wx/config',
      //           authId: 104,
      //         },
      //       ],
      //     },
      //     {
      //       name: '公众号',
      //       path: '/app-center/channel/vx-config',
      //       authId: 27,
      //     },
      //   ],
      // },
    ],
  },
  {
    name: '包材四码',
    shortName: '包材四码',
    path: '/box',
    authId: 0,
    icon: 'iconyunchashezhi',
    routes: [
      {
        name: '箱码',
        authId: 1161,
        path: '/app-center/box/code',
        routes: [
          {
            name: '活动列表',
            path: '/app-center/box/code/activity_list',
            authId: 1162,
          },
          {
            name: '用户数据',
            path: '/app-center/box/code/user_data',
            authId: 1164,
          },
        ],
      },
      {
        name: 'UTC',
        authId: 1189,
        path: '',
        routes: [
          {
            name: '活动列表',
            path: '/app-center/utc/activity_list',
            authId: 1190,
          },
          {
            name: '用户数据',
            path: '/app-center/utc/user_data',
            authId: 1191,
          },
          {
            name: '外部关联',
            authId: 1192,
            path: '/app-center/utc/external_reference',
          },
        ],
      },
    ],
  },
  {
    name: '码管理平台',
    shortName: '码管理平台',
    path: '/code-platform',
    authId: 1217,
    icon: 'iconyunchayingyongzhongxin',
    routes: [
      {
        name: '码包提取',
        authId: 1218,
        path: '/app-center/code-platform/code-extract',
      },
      {
        name: '提取记录',
        authId: 1219,
        path: '/app-center/code-platform/extract-record',
      },
    ],
  },
  {
    name: '全域数据',
    shortName: '全域数据',
    path: '/',
    authId: 1182,
    icon: 'iconyunchashezhi',
    routes: [
      {
        name: '数据看板',
        authId: 1183,
        path: '/dashboard',
      },
    ],
  },
];

const generateRoutes = (routesConfig, parent) => {
  routesConfig.forEach((r) => {
    if (parent) {
      r.parents = (parent.parents || []).concat({
        path: parent.path,
        name: parent.name,
      });
    }
    if (r.routes && r.routes.length > 0) {
      generateRoutes(r.routes, r);
    }
  });
};

generateRoutes(routesConfig);

export default routesConfig;
